module.exports = __webpack_public_path__ + "static/img/icon-container.45004ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-container.png
// module id = /cjE
// module chunks = 36